<template>
  <div class="dropdown">
    <div v-if="thereIsData" class="dropdown__user dropup" id="dropdownMenu">
      <div
        class="float-user dropdown-button box-shadow"
        id="userIcon"
        :style="{ backgroundColor: $store.getters.showStatusColor }"
        type="text"
        ref="dropdown"
        data-toggle="dropdown"
        aria-label="float button for user"
        aria-haspopup="true"
        aria-expanded="false"
        v-b-popover.hover.top="
          $store.getters['login/showUserLoggedIn'][0].user.username
        "
      >
        <div class="float-user__icon">
          <b-icon
            v-if="!changingStatus"
            class="float-user__icon--waiting"
            icon="person-fill"
            aria-hidden="true"
          ></b-icon>
          <b-icon
            v-if="changingStatus"
            class="float-user__icon--waiting"
            icon="arrow-counterclockwise"
            animation="spin-reverse-pulse"
          ></b-icon>
        </div>
      </div>

      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <p class="dropdown-menu--username">
          <b>{{ $store.getters["login/showUserLoggedIn"][0].user.username }}</b>
        </p>
        <div v-if="departmentOption.length >= 1">
          <hr class="separation" />
          <b-dropdown
            dropright
            no-caret
            aria-label="Change of department"
            variant="transparent"
            class="d-flex justify-content-center mr-2"
          >
            <template #button-content>
              <b-icon
                class="dropdown-menu--change-department"
                icon="arrow-right-circle-fill"
              ></b-icon>
              {{ selectDepartment }}
            </template>
            <b-dropdown-item
              v-for="(departments, index) of departmentOption"
              :key="index"
              aria-label="LTL Department"
              class="dropdown-item__department"
              @click="selectedDepartment(departments)"
            >
              {{ departments }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <hr class="separation" />
        <button
          aria-label="Change user status to active"
          v-if="$store.getters['login/showUserLoggedIn'][0].is_busy"
          class="dropdown-item"
          @click="changeStatus"
        >
          <b-icon
            class="dropdown-menu--active"
            icon="check-circle-fill"
          ></b-icon>
          Active
        </button>
        <hr
          v-if="$store.getters['login/showUserLoggedIn'][0].is_busy"
          class="separation"
        />
        <button
          aria-label="Change user status to busy"
          v-if="!$store.getters['login/showUserLoggedIn'][0].is_busy"
          class="dropdown-item"
          @click="changeStatus"
        >
          <b-icon class="dropdown-menu--busy" icon="clock-fill"></b-icon>
          Busy
        </button>
        <hr
          v-if="!$store.getters['login/showUserLoggedIn'][0].is_busy"
          class="separation"
        />
        <button
          aria-label="Logout from CharlieBot"
          class="dropdown-item"
          @click="signOut"
        >
          <i class="fa fa-sign-out-alt dropdown-menu--logout"></i>
          Logout
        </button>
      </div>
    </div>

    <div class="header" aria-label="Header menu">
      <HeaderMobile />
    </div>

    <div class="sidebar" aria-label="Sidebar menu">
      <Sidebar />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebar from "@/layout/Sidebar";
import HeaderMobile from "@/layout/HeaderMobile";
import { warningMessage } from "@/api/errorMessages";

export default {
  name: "Dropdown",
  components: {
    Sidebar,
    HeaderMobile
  },
  data() {
    return {
      thereIsData: false,
      changingStatus: false,
      departmentOption: [],
      selectDepartment: null,
      userDepartment: null,
      totalAssigned: null,
      totalFailed: null
    };
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"])
  },
  watch: {
    async showInfoDepartment() {
      setTimeout(() => {
        let user = localStorage.getItem("charlie-username-otr");
        this.$store.commit("login/setUserLoggedIn", JSON.parse(user));
        this.setUserStyle();
      }, 5000);
    }
  },
  beforeMount() {
    let user = localStorage.getItem("charlie-username-otr");
    this.$store.commit("login/setUserLoggedIn", JSON.parse(user));
    this.getDepartmentOption();
    this.thereIsData = true;
  },
  mounted() {
    this.setUserStyle();
  },
  methods: {
    setUserStyle() {
      if (this.$store.getters["login/showUserLoggedIn"][0].is_busy) {
        this.$store.commit("setStatusColor", "#e53935");
      } else {
        this.$store.commit("setStatusColor", "#4caf50");
      }
    },
    async changeStatus() {
      this.currentDepartment = JSON.parse(
        localStorage.getItem("current-department")
      );
      let info = {};
      let infoInProcess = {};
      info.department = this.currentDepartment.department_id;
      info.userId = this.$store.getters["login/showUserLoggedIn"][0].user.id;
      info.departmentId = this.$store.getters[
        "login/showUserLoggedIn"
      ][0].department.id;
      info.rolId = this.$store.getters["login/showUserLoggedIn"][0].rol.id;
      info.isBusy = {};
      info.isBusy.is_busy = !this.$store.getters["login/showUserLoggedIn"][0]
        .is_busy;
      infoInProcess.department = info.department;
      infoInProcess.status = 3;
      infoInProcess.entry_type = [
        "GRAPH",
        "Manual",
        "GRAPH-KNSUPPORT",
        "GRAPH-LATINPRO"
      ];
      if (
        this.$store.getters["login/showUserLoggedIn"][0].rol.name !==
        "superuser"
      ) {
        await this.getQuotesAssigned(info);
        await this.getQuotesFailed(info);
        const totalInProcess = await this.$store.dispatch(
          "quotes/getTotalQuotes",
          infoInProcess
        );
        this.totalAssigned = this.$store.getters[
          "quotes/showTotalQuotesAssigned"
        ];
        this.totalFailed = this.$store.getters["quotes/showTotalQuotesFailed"];
        if (this.totalAssigned !== 0 || this.totalFailed !== 0) {
          this.message = `Please, Remember that you have pending quotes:
            My Queue: ${this.totalAssigned}
            In Process: ${totalInProcess.data}
            Failed: ${this.totalFailed}`;
        }
        const isConfirm = await warningMessage(this.message);
        if (isConfirm) {
          document.getElementById("userIcon").style.backgroundColor =
            "rgba(171, 178, 185, 0.3)";
          this.changingStatus = true;
          await this.$store.dispatch(
            "usersManagement/userConfig/changeStatus",
            info
          );
          await this.$store.dispatch("login/getUsername", info.departmentId);
        }
      } else {
        document.getElementById("userIcon").style.backgroundColor =
          "rgba(171, 178, 185, 0.3)";
        this.changingStatus = true;
        await this.$store.dispatch(
          "usersManagement/userConfig/changeStatus",
          info
        );
        await this.$store.dispatch("login/getUsername", info.departmentId);
      }
      this.changingStatus = false;
      this.setUserStyle();
    },
    signOut() {
      localStorage.removeItem("charlie-otr-token");
      localStorage.removeItem("charlie-user-department");
      localStorage.removeItem("actual-queue");
      localStorage.removeItem("current-department");
      this.$router.push({ name: "Login" });
    },
    async selectedDepartment(value) {
      this.departmentOption = [];
      this.selectDepartment = value;
      for (let i in this.userDepartment) {
        let dto =
          this.userDepartment[i].department_name.toUpperCase() +
          " " +
          this.userDepartment[i].rol_name;
        if (dto == value) {
          this.$store.commit("login/setInfoDepartment", this.userDepartment[i]);
          localStorage.setItem(
            "current-department",
            JSON.stringify(this.userDepartment[i])
          );
          this.$store.commit(
            "login/setToken",
            this.userDepartment[i].access_token
          );
          localStorage.setItem(
            "charlie-otr-token",
            this.userDepartment[i].access_token
          );
          let userDto = {};
          userDto = this.userDepartment[i].department_id;
          this.$store.dispatch("login/getUsername", userDto);
          if (this.$route.params.pathName !== "queue") {
            this.$router.push({
              name: "Emails",
              params: {
                pathName: "queue"
              }
            });
          }
        }
      }
      this.getDepartmentOption();
    },
    getDepartmentOption() {
      let department = localStorage.getItem("charlie-user-department");
      this.userDepartment = JSON.parse(department);
      this.currentDepartment = JSON.parse(
        localStorage.getItem("current-department")
      );
      this.$store.commit("login/setInfoDepartment", this.currentDepartment);
      this.selectDepartment =
        this.currentDepartment.department_name.toUpperCase() +
        " " +
        this.currentDepartment.rol_name;
      this.userDepartment.forEach(element => {
        if (
          this.currentDepartment.department_name != element.department_name ||
          this.currentDepartment.rol_name != element.rol_name
        ) {
          this.departmentOption.push(
            element.department_name.toUpperCase() + " " + element.rol_name
          );
        }
      });
      let actualQueue;
      if (this.currentDepartment.department_id == 2) {
        if (localStorage.getItem("actual-queue")) {
          actualQueue = localStorage.getItem("actual-queue");
        } else {
          actualQueue = "ftl";
        }
        this.$store.commit("quotes/setActualQueue", actualQueue);
        localStorage.setItem("actual-queue", actualQueue);
      } else {
        localStorage.removeItem("actual-queue");
      }
    },
    async getQuotesAssigned(info) {
      info.status = 2;
      let quotesAssigned = await this.$store.dispatch(
        "quotes/getTotalQuotesAssigned",
        info
      );
      this.$store.commit("quotes/setTotalQuotesAssigned", quotesAssigned.data);
    },
    async getQuotesFailed(info) {
      info.status = 4;
      let quotesFailed = await this.$store.dispatch(
        "quotes/getTotalQuotes",
        info
      );
      this.$store.commit("quotes/setTotalQuotesFailed", quotesFailed.data);
    }
  }
};
</script>

<style lang="scss" scoped>
$margin-left-icons: 10px;

hr:not([size]) {
  height: 0px;
}

.table > :not(:last-child) > :last-child > * {
  border-bottom: none;
}

.header {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.4s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.float-user {
  bottom: 3%;
  left: 1.8%;
  position: fixed;
  width: 30px;
  height: 30px;
  color: $color-light;
  border-radius: 50%;
  @include justify-items-center;
  cursor: pointer;
  &__icon {
    margin-top: 3px;
    &--waiting {
      font-size: 22px;
    }
  }
}

.dropdown__user {
  z-index: 10000;
}

.dropdown-menu {
  &--username {
    text-align: center;
    text-transform: uppercase;
    padding: 0px 10px;
  }
  &--change-department {
    color: $color-primary-button;
    margin-right: $margin-left-icons;
    margin-left: 0.65rem;
  }
  &--active {
    color: $color-user-active;
    margin-right: $margin-left-icons;
  }
  &--busy {
    color: $color-user-busy;
    margin-right: $margin-left-icons;
  }
  &--logout {
    color: #ffc107;
    margin-right: $margin-left-icons;
  }
}

.form-control {
  background-color: $color-background-input !important;
  &:hover {
    @include box-shadow;
  }
  &:focus {
    border-color: get-opacity($color-gray-shadow, 80%) !important;
    box-shadow: 0 0 0 0.2rem get-opacity($color-gray-shadow, 40%) !important;
  }
}

.separation {
  @include margin-card-hr;
}

.box-shadow {
  @include box-shadow;
}

@media (max-width: 1400px) {
  .float__user {
    left: 2%;
  }
}

@media (max-width: 991px) {
  .sidebar {
    display: none;
  }
  .header {
    display: block;
  }
}
</style>
